import { DadosServiceAbstract } from "./dados.service-abstract";
import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { setTableNamePrefix,setConfig, getConfig } from "./data.model";
import { AngularFirestore } from "angularfire2/firestore";
import { HttpModule } from "@angular/http";

@NgModule({
    imports: [ CommonModule,HttpModule, ],
  })
  export class DadosModule {
    public static forRoot(cfg): ModuleWithProviders {
      if (getConfig()==undefined)
         setConfig(cfg);
      setTableNamePrefix(cfg.prefix);



      return {
        ngModule: DadosModule,
        providers: [
          DadosServiceAbstract,
          //{ provide: 'configDados', useValue: config }
        ]
      };
    }
   constructor( private db: AngularFirestore){
     //console.log("settings");
     //this.db.firestore.settings({timestampsInSnapshots: true})
   }  
  }
  